import { api } from "./http-client";
import { BackgroundTask } from "../interfaces/background-task.interface";
import { PageDto, PageOptionsDto } from "../types/pagination";

export const YACHT_WORLD_IMPORT_TASK_TYPE = "yacht_world_import";

export const backgroundTasksService = {
  list: async (
    params?: PageOptionsDto & { type?: string; status?: string; section?: string },
  ): Promise<PageDto<BackgroundTask>> => {
    const response = await api.request<PageDto<BackgroundTask>>({
      url: "/background-tasks",
      method: "GET",
      params,
    });
    return response.data;
  },
};
